import { CheckCircle, Sparkles } from "lucide-react";
import ScanAdsTicker from "../ScanAdsTicker";

export const LoadingScreen = ({ t, step }) => {
  const steps = [t.scanning_seo, t.checking_ai, t.analyzing_geo, t.generating];
  
  return (
    <div className="loading-overlay" data-testid="loading-screen">
      <div className="text-center">
        <div className="mb-8">
          <Sparkles className="w-16 h-16 text-blue-600 mx-auto animate-pulse" />
        </div>
        <h2 className="text-2xl font-bold mb-4 font-['Chivo']">{t.analyzing}</h2>
        <div className="loading-scanner mb-6" />
        <div className="space-y-2">
          {steps.map((s, i) => (
            <div key={i} className={`flex items-center justify-center gap-2 ${i <= step ? 'text-blue-600' : 'text-gray-400'}`}>
              {i < step ? (
                <CheckCircle className="w-4 h-4" />
              ) : i === step ? (
                <div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
              ) : (
                <div className="w-4 h-4 border border-gray-300 rounded-full" />
              )}
              <span className="text-sm">{s}</span>
            </div>
          ))}
        </div>

        {/* V232.5 — Rotating success-story ads during the 30-45s scan.
            Turns dead wait time into social proof reel. */}
        <ScanAdsTicker variant="light" />
      </div>
    </div>
  );
};
